
export default {
  priority: 11,
  path: "user",
  permissions: ["TimeAttendanceMenu/SmsMenu","afa244366dafa24366d32ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f1895932ebde43b4a30068dccc68a779b3ac8543aea48e320b22d99f18959"],
  // component: Users,
  // component: load(() =>
  //   import(/* webpackChunkName: "Setting-Users" */ "./Sms")
  // ),
  name: app.translate("پیامک"),
  icon: "account-check",
  drawer: true,
};
